import { Filter } from '../../domain/Filter';
import { EstimationMonthSum } from '../../domain/estimations/Estimations';
import Order, { OrderedSku, SumValues } from '../../domain/Order';
import SummaryData from '../../domain/SummaryData';
import { LiabilityMet } from '../../domain/isLiabilityMet';

export enum PlacingOderStatus {
    Null,
    Progress
}

export default interface State {
    articlesEstimations: EstimationMonthSum;
    order?: Order;
    savedOrder?: Order;
    orderFilters: Filter[];
    searchQuery: string;
    orderDetails: SummaryData | null;
    orderedSku: OrderedSku;
    deliveryFee: number;
    liabilityMet: LiabilityMet;
    placingOrderStatus: PlacingOderStatus;
    orderedStock: SumValues;
    orderedCheckout: SumValues;
    estimated: SumValues;
}



// WEBPACK FOOTER //
// ./src/application/order/State.ts